var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisabledPersonBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.979,
    height: 21.002,
    viewBox: "0 0 15.979 21.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#343434;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-61.233)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.233 5.482)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M77.171,147.455,75.8,141.52a1.368,1.368,0,0,0-1.329-1.037H71.811a5.713,5.713,0,0,0-1.448-1.6V135a1.378,1.378,0,0,0-1.982-1.225l-2.739,1.37a1.358,1.358,0,0,0-.752,1.225v1.752l-.026.007a5.706,5.706,0,1,0,7.772,5.089H73.4l1.11,4.9a1.37,1.37,0,1,0,2.658-.665Zm-10.231.332a4.333,4.333,0,0,1-2.05-8.152v1.76a1.367,1.367,0,1,0,2.735,0v-2.242a.677.677,0,0,0,.1.03,4.338,4.338,0,0,1-.789,8.6Z",
    transform: "translate(-61.233 -133.638)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.168)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M207.972,0a2.054,2.054,0,1,0,2.054,2.054A2.057,2.057,0,0,0,207.972,0Z",
    transform: "translate(-205.918)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledPersonBlack);
export default __webpack_public_path__ + "static/media/disabled-person-black.8fa0c218bf8a6d948b0b03d2e055cef1.svg";
export { ForwardRef as ReactComponent };